import { Component } from '@angular/core';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html'
})
export class AppComponent {
  
}



// WEBPACK FOOTER //
// D:/TMB/TMB/MYTMB.UI/src/app/app.component.ts